var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.462 8.051c0-1.35 1.09-2.44 2.44-2.44s2.44 1.09 2.44 2.44v26.01l7.65-7.46a2.56 2.56 0 0 1 3.56 0c.98.96.98 2.52 0 3.48l-11.74 11.45s-.09.1-.14.14c-.98.96-2.58.96-3.56 0l-11.88-11.58c-.98-.96-.98-2.52 0-3.48a2.56 2.56 0 0 1 3.56 0l7.66 7.47V8.051z",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowDown;